import { ROUTE_LOADING_TYPE } from '@constants/index';
import { FormattedMessage } from 'react-intl';
import PageLoading from '../UI/PageLoading';

function RouteLoading({ type = ROUTE_LOADING_TYPE.ROUTE_LAZY_LOADING }) {
  switch (type) {
    case ROUTE_LOADING_TYPE.ROUTE_PERMISSION_CHECK:
      return (
        <PageLoading>
          <FormattedMessage
            id="CHECKING_PERMISSIONS"
            defaultMessage="Checking Permissions..."
          />
        </PageLoading>
      );
    default:
      return (
        <PageLoading>
          <FormattedMessage
            id="LOADING_PAGE"
            defaultMessage="Loading Page..."
          />
        </PageLoading>
      );
  }
}

export default RouteLoading;
